import { useContext } from 'react';
import { formatCurrencyValue } from '../../../../shared/format-currency.js';
import { AppCtx } from '../../app-context.jsx';
import { redactedWidth } from './redacted-width.js';

/**
 * @param {Object} props
 * @param {number|null|undefined} props.value
 * @param {number|undefined} props.decimalPlaces
 * @param {string|undefined} props.symbol
 * @param {boolean} [props.masked] — redact the amount when private mode is on
 * @returns {JSX.Element}
 */
export function Amount({ value, decimalPlaces, symbol, masked = false }) {
	const ctx = useContext(AppCtx);
	const privateMode = ctx?.privateMode === true;

	if (masked && privateMode && value !== null && value !== undefined && Number.isFinite(value)) {
		return (
			<span
				className="amount-redacted"
				style={{ width: `${redactedWidth(value)}em` }}
				aria-hidden="true"
			/>
		);
	}

	const metadataKnown = symbol && typeof symbol === 'string' && Number.isFinite(decimalPlaces);
	if (!metadataKnown || value === null || value === undefined || !Number.isFinite(value)) {
		return <span className="amount amount-na">&mdash;</span>;
	}

	const className = [
		'amount',
		value < 0 ? 'report-loss' : '',
	].filter(Boolean).join(' ');

	return (
		<span className={className}>
			{formatCurrencyValue(value, decimalPlaces, symbol)}
		</span>
	);
}
